<template>
  <div class="page-search-list-container">
    <div class="search-list-container__head" :class="{
      '--is-product': type === 'product',
    }">
      <div class="head__wrapper">
        <div class="head__title" :class="[$isMobile ? '' : '--has-publish-bt']">
          <p>{{ pageTitle }}</p>
          <template v-if="!$isMobile">
            <template v-if="publishBtGrant.publishURL">
              <template v-if="type != 'lq'">
                <div class="common-publish-bt" @click="commonPublish" v-if="isPublishShow">
                  发布
                </div>
              </template>
            </template>
            <template v-else>
              <div class="common-publish-bt --bg-blue" @click="getjoinin"
                v-if="!userInfo || (userInfo && userInfo.isMerchant && !userInfo.isAuthMerchant)">
                入驻
              </div>
              <div class="common-publish-bt --bg-blue" @click="getupgrade" v-if="userInfo && userInfo.isMerchant && userInfo.isAuthMerchant && userInfo.type === 2
                ">
                升级
              </div>
            </template>
          </template>
          <template v-else>
            <div class="form__result" v-if="total">showing {{ total.num }} results</div>
          </template>
        </div>
        <div class="search-list__form">
          <div class="form__result" v-if="total && !$isMobile">showing {{ total.num }} results</div>
          <div class="form__main-body">
            <div class="form__group" v-if="!$isMobile">
              <i v-if="form.search_file == ''" class="form__group--icon icon icon-search --gray"></i>
              <input type="text" class="form__group--input" v-model="form.search" @keyup.enter="gosearch"
                placeholder="输入关键词搜索" v-if="form.search_file == ''" />
              <p style="margin: 5px" v-if="form.search_file != ''">
                <label style="font-size: 20px; margin-top: 5px">按图搜索结果</label>
                <i class="el-icon-close" style="font-size: 20px; cursor: pointer" @click="cancelSearchFile"></i>
              </p>
              <!-- <el-image v-if="localstorage.get('TOKEN')" class="icon-bdImg" :src="bdImg"></el-image> -->
              <div class="icon-bdImg" v-if="type != 'synopsis' && type != 'requirement' && type != 'dynamic' && false">
                <p>按图片搜索</p>
                <el-upload v-if="localstorage.get('TOKEN')" ref="uploadBD" class="baiduSearch-uploader" action="#"
                  :data="uploadData" :show-file-list="false" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="form__group --drop-selections" @click="showSelections" :data-type="drop.type"
              v-show="type != 'lq' && form.search_file == ''" v-for="(drop, index) in dropSelections" :key="index">
              <label for="" class="form__group--label">{{
                clickText[drop.type] ? clickText[drop.type] : drop.name
              }}</label>
              <i class="form__group--arrow icon icon-bottom-arrow --yellow" :class="{
                  isActived: drop.active,
                }"></i>
            </div>
          </div>
          <div class="form__drop-selections-container" v-show="type != 'lq' && form.search_file == ''" v-if="items"
            ref="selections-container">
            <div class="drop__wrapper">
              <a href="javascript:void(0);" class="drop__item" v-for="item in items.lists" :key="item.id" :class="{
                active:
                  items.type === 'mold'
                    ? Number(form.mold_id) === Number(item.id)
                    : Number(form.prov_id) === Number(item.id),
              }" @click="
  getQuery({
    [items.type === 'mold' ? 'mold_id' : 'prov_id']: item.id,
  }),
  showActive(items.type, item.name)
  ">
                {{ item.name }}
              </a>
            </div>
          </div>
          <div class="form_drop-child-contaier" v-if="hasMoldChild && moldOpen && moldChildren"
            ref="selections-container-child" :style="{
              top: `${topOffset}px`,
            }">
            <div class="drop__wrapper">
              <a href="javascript:void(0);" class="drop__item" v-for="child in moldChildren" :key="child.id" :class="{
                active: Number(form.mold_ids) === Number(child.id),
              }" @click="
  getQuery({
    mold_ids: child.id,
  }),
  showActive('childMold', child.name)
  ">{{ child.name }}</a>
            </div>
          </div>
          <div class="form_drop-mobile-bt" ref="mobileBt" v-if="items && $isMobile" :class="{
            height1: items,
            height2: items && hasMoldChild && moldOpen && moldChildren,
          }">
            <div class="bt__item --cancel" v-if="!(hasMoldChild && moldOpen && moldChildren)" @click="onMobileDropCancel">
              重置
            </div>
            <div class="bt__item --last-step" v-else @click="onMobileLastStep">上一步</div>
            <div class="bt__item --submit" @click="onMobileDropSubmit">确定</div>
          </div>
          <div class="form_drop-bg" ref="mobileBg" v-if="items"></div>
        </div>
        <div v-if="!$isMobile && this.type == 'requirement'" class="demand-expand-container">
          <el-checkbox v-model="pointDemand">只看重点项目</el-checkbox>
        </div>
        <div v-if="type == 'lq' && !form.search && !form.search_file" style="">
          百万案例库，试试搜索并认领你参与过的案例！| powered by 零泉
        </div>
        <br />
      </div>
    </div>
    <div class="search-list-container__main" :class="{
      '--is-product': type === 'product',
    }">
      <div class="main__wrapper">
        <div class="main__search-content">
          <template v-if="loading">
            <div class="loading-text" style="position: absolute; top: 0; left: 0">加载中</div>
          </template>
          <template v-else>
            <CaseList v-if="type === 'case'" :isShowPagination="total" :cases="lists"></CaseList>
            <LqList v-else-if="type === 'lq'" :isShowPagination="total" :lqs="lists"></LqList>
            <ProductList v-else-if="type === 'product'" :isShowPagination="total" :products="lists"></ProductList>
            <RequirementsList v-else-if="type === 'requirement'" :isShowPagination="total" :requirements="lists">
            </RequirementsList>
            <MerchantList v-else-if="type === 'merchant'" :isShowPagination="total" :merchants="lists"></MerchantList>
            <ArticleList v-else-if="type === 'article'" :isShowPagination="total" :articles="lists"></ArticleList>
            <DynamicList v-else-if="type === 'dynamic'" :isShowPagination="total" :dynamics="lists"></DynamicList>
            <SampleList :samples="lists" v-else-if="type === 'sample'" :isShowPagination="total"></SampleList>
            <SynopsisList v-if="type === 'synopsis'" :isShowPagination="total" :requirements="lists"></SynopsisList>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { molds, upload } from "@/api/common";
import { SEARCH_TITLE_MAP } from "@/assets/utils/dict";
import { checkoutLogin, commonPublish } from "@/assets/utils/handler";
import localstorage from "@/assets/utils/localstorage";
import ArticleList from "@/pages/article/_list.vue";
import CaseList from "@/pages/case/_list.vue";
import DynamicList from "@/pages/dynamic/_list.vue";
import LqList from "@/pages/lq/_list.vue";
import MerchantList from "@/pages/merchant/_list.vue";
import ProductList from "@/pages/product/_list.vue";
import RequirementsList from "@/pages/requirement/_list.vue";
import SampleList from "@/pages/sample/_list.vue";
import SynopsisList from "@/pages/synopsis/_list.vue";
import { Message } from "element-ui";
import { mapState } from "vuex";

// const wrapper = document.querySelector('.base-bone__wrapper');
// const wrapperZindex = getComputedStyle(wrapper, null)['z-index'];
// const bodyHidden = getComputedStyle(document.body, null).overflow;
// console.log(bodyHidden);

const headerHeight = document
  .querySelector(".header-wrapper-container")
  .getBoundingClientRect().height;
let searchHeaderHeight = 0;

export default {
  components: {
    CaseList,
    LqList,
    ProductList,
    MerchantList,
    RequirementsList,
    ArticleList,
    DynamicList,
    SampleList,
    SynopsisList,
  },
  data() {
    return {
      type: this.$route.params.type,
      // 新的
      lists: [],
      cf_token: [],
      items: null,
      dropSelections: [
        {
          name: "所有标签",
          type: "mold",
          active: false,
        },
        {
          name: "全国",
          type: "city",
          active: false,
        },
      ],
      form: {
        page: 1,
        page_size: this.$isMobile ? 16 : 15,
        prov_id: null,
        mold_id: null,
        mold_ids: null,
        search: this.$route.params.keyword,
        search_file: this.$route.query.file ? this.$route.query.file : "",
      },
      total: null,
      hasMoldChild: true,
      moldChildren: null,
      moldOpen: false,
      clickText: {
        mold: "",
        moldParent: "",
        moldChildren: "",
        city: "",
      },
      bdImg: require("../../assets/images/icons/icon-bdImg.png"),
      uploadData: {
        access_token: "",
      },
      localstorage,
      pointDemand: false,
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
    molds: (state) => state.molds,
    cities: (state) => state.cities,
    loading: (state) => state.pageloading,
    pageTitle() {
      return SEARCH_TITLE_MAP[this.type].title;
    },
    publishBtGrant() {
      return SEARCH_TITLE_MAP[this.type];
    },
    isPublishShow() {
      const grant = [];
      if (!this.userInfo) {
        grant.push(0);
      } else if (this.userInfo && this.userInfo.isMerchant) {
        grant.push(2);
      } else if (this.userInfo && !this.userInfo.isMerchant) {
        grant.push(1);
      }
      return grant.some((item) => this.publishBtGrant.showGrant.some((g) => g === item));
    },
    topOffset() {
      return headerHeight + searchHeaderHeight;
    },
  }),
  watch: {
    pointDemand: {
      handler() {
        this.init();
      },
    },
    $route: {
      handler() {
        this.initQuery();
        this.init();
      },
      immediate: true,
    },
    form: {
      handler() { },
      deep: true,
    },
    type: {
      handler(val) {
        const label = {
          name: "所有标签",
          type: "mold",
          active: false,
        };
        const city = {
          name: "全国",
          type: "city",
          active: false,
        };
        const tempDrop = [];
        if (val === "requirement" || val === "dynamic" || val === "article" || val === "synopsis") {
          tempDrop.push(label);
        } else {
          tempDrop.push(label, city);
        }
        this.dropSelections = tempDrop;
        // 清除items状态
        this.showSelections();
      },
      immediate: true,
    },
    items(val) {
      console.log(val);
    },
  },
  created() {
    // console.log('created');
    // this.init();
  },
  mounted() {
    this.$nextTick(() => {
      searchHeaderHeight = document
        .querySelector(".search-list-container__head")
        .getBoundingClientRect().height;
    });
  },
  methods: {
    cancelSearchFile() {
      console.log("ssss");
      this.$router.push({
        path: `/search/${this.type}`,
        query: {
          keyword: "",
        },
      });
    },
    initQuery() {
      const val = this.$route;
      this.type = val.params.type;
      this.form.prov_id = val.query.prov_id || null;
      this.form.mold_id = val.query.mold_id || null;
      this.form.mold_ids = val.query.mold_ids || null;
      this.form.search = val.query.keyword || null;
      this.form.search_file = val.query.file || "";
    },
    async init() {
      // 基础数据初始化
      this.lists = [];
      this.hasMoldChild = !(this.type === "article");
      // 获取列表数据
      this.$store.commit("openLoading");
      const res = await this.getLists();
      if (this.form.mold_id > 0 && this.hasMoldChild) {
        const moldChildren = await this.getMoldChild();
        const moldChildrenLists = moldChildren.data.list;
        this.moldChildren = moldChildrenLists;
      }
      const { list, total } = res.data;
      console.log(res.data);
      this.lists = list;
      this.total = total;
      this.$store.commit("closeLoading");
    },
    //简介
    getSynopsisList() {
      // const url = 'html/index/caseShow';
      const url = "html/index/materialcatalogueShow";
      this.form.page_size = 16;
      return {
        url,
        form: this.form,
      };
    },
    getCaseList() {
      const url = "html/index/caseShow";
      this.form.is_recommend = 0;
      this.form.page_size = this.$isMobile ? 16 : 15;
      return {
        url,
        form: this.form,
      };
    },
    getLqList() {
      const url = "html/index/lqShow";
      this.form.is_recommend = 0;
      this.form.page_size = this.$isMobile ? 16 : 15;
      return {
        url,
        form: this.form,
      };
    },
    getRequirementList() {
      const url = "html/demand/index";
      this.form.page_size = 16;
      return {
        url,
        form: this.form,
      };
    },
    getProductList() {
      const url = "html/index/productShow";
      this.form.page_size = 16;
      return {
        url,
        form: this.form,
      };
    },
    getMerchantList() {
      const url = "html/index/storeShow";
      this.form.page_size = 30;
      return {
        url,
        form: this.form,
      };
    },
    // 讯有
    getUserInfo() {
      this.cf_token = localstorage.get("TOKEN");
      const url = "html/user/myInfo";
      this.form.access_token = this.cf_token;
      return {
        url,
        form: this.form,
      };
    },
    getDynamicList() {
      const url = "html/Dynamic/index";
      this.form.page_size = this.$isMobile ? 10 : 9;
      return {
        url,
        form: this.form,
      };
    },
    getArticleList() {
      const url = "html/index/knowledgeShow";
      this.form.type = 2;
      this.form.page_size = 20;
      return {
        url,
        form: this.form,
      };
    },
    getSampleList() {
      const url = "html/index/sampleShow";
      this.form.page_size = 16;
      return {
        url,
        form: this.form,
      };
    },
    getMoldChild() {
      return molds(this.form.mold_id);
    },
    getLists(params = null) {
      const methodName = `get${this.type.replace(/^\S/, (s) => s.toUpperCase())}List`;
      const requestInfo = this[methodName]();
      const { url, form } = requestInfo;

      if (this.type === "requirement") {
        form["point_demand"] = this.pointDemand;
      }

      // if(this.type!='lq'&&this.form.search!=''){
      const page = this.$route.query.page || 1;
      form.page = page;
      return this.$http.post(url, form);
      // }
      // else{
      //   return {"success":true,"desc":"","errorcode":"","data":{"list":[]}};
      // }
    },
    showSelections(e) {
      let styles;
      if (e) {
        const target = e.currentTarget;
        const { type } = target.dataset;
        const lists = type === "mold" ? this.molds : this.cities;
        // if (this.$isMobile) {
        //   lists = sliceGroup(lists, 20);
        // }
        this.items = {
          type,
          lists,
        };
        let openSwitch = false;
        this.dropSelections.map((item) => {
          const temp = item;
          temp.active = temp.type === type && !temp.active;
          if (temp.type === type) {
            openSwitch = temp.active;
          }
          return temp;
        });
        this.moldOpen = type === "mold" && openSwitch;
        this.$nextTick(() => {
          const container = this.$refs["selections-container"];
          if (openSwitch) {
            const childContainer = container.firstChild;
            const childHeight = childContainer.getBoundingClientRect().height;
            if (this.$isMobile) {
              this.$refs.mobileBt.style.cssText = "visibility: visible;";
              this.$refs.mobileBg.style.cssText = "visibility: visible;";
              document.body.classList.add("open-search-type");
              styles = `visibility: visible;top:${this.topOffset}px;`;
            } else {
              styles = `visibility: visible;height:${childHeight}px;`;
            }
          } else {
            styles = "visibility: hidden;height:0px;";
            if (this.$isMobile) {
              this.$refs.mobileBt.style.cssText = "visibility: hidden;";
              this.$refs.mobileBg.style.cssText = "visibility: hidden;";
              document.body.classList.remove("open-search-type");
            }
          }
          container.style.cssText = styles;
        });
      } else {
        this.moldOpen = false;
        this.items = null;
        this.moldChildren = null;
        this.dropSelections.map((item) => {
          const temp = item;
          temp.active = false;
          return temp;
        });
        if (this.$isMobile) {
          document.body.classList.remove("open-search-type");
        }
      }
    },
    getQuery(query) {
      const temp = Object.assign(JSON.parse(JSON.stringify(this.$route.query)), query);
      if (Object.keys(query)["0"] === "mold_id") {
        delete temp.mold_ids;
      }
      temp.page = 1;
      this.$router.push({
        path: this.$route.path,
        query: temp,
      });
    },
    gosearch() {
      this.$router.push({
        path: `/search/${this.type}`,
        query: {
          keyword: this.form.search,
        },
      });
    },
    goLqImageSearch(file) {
      this.$router.push({
        path: `/search/${this.type}`,
        query: {
          file: file,
        },
      });
    },

    commonPublish() {
      commonPublish(this.type);
    },
    getjoinin() {
      checkoutLogin();
    },
    getupgrade() {
      this.$router.push({
        path: "/my/auth",
      });
    },
    onMobileDropCancel() {
      this.clickText.mold = null;
      this.clickText.moldParent = null;
      this.clickText.moldChildren = null;
      this.clickText.city = null;
      this.$router.push({
        path: this.$route.path,
      });
      this.showSelections();
    },
    onMobileDropSubmit() {
      this.showSelections();
    },
    onMobileLastStep() {
      this.moldChildren = null;
    },
    showActive(type, name) {
      if (type === "mold") {
        this.clickText.moldParent = name;
        this.clickText.mold = `${this.clickText.moldParent}`;
      } else if (type === "city") {
        this.clickText.city = name;
      } else if (type === "childMold") {
        this.clickText.moldChildren = name;
        this.clickText.mold = `${this.clickText.moldParent} / ${this.clickText.moldChildren}`;
      }
    },
    beforeAvatarUpload(file) {
      //image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp
      // console.log(file, 'file')
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpg";
      const isLt5M = file.size / 1024 / 1024 < 8;
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error("上传图片只能是 JPG, jpeg, png  格式!");
        return false;
      }
      if (!isLt5M) {
        Message({
          type: "warning",
          message: `上传图片大小不能超过 8MB!`,
        });
        return false;
      }
      this.uploadData.access_token = localstorage.get("TOKEN");
      this.preLoad = [];
      this.preLoad.push(file);
      upload(this.preLoad).then((res) => {
        // if (this.type == 'case' ||this.type == 'case' || this.type == 'product' || this.type == 'merchant' || this.type == 'knowledge') {
        this.goLqImageSearch(res[0].data.self_url);
        return;
        // }
        // baiduSearch(res[0].data.id).then((resS) => {
        //   this.form.search = resS.data.name
        //   this.gosearch()
        // })
      });
      return true;
    },
  },
};
</script>

<style lang="scss">
.form__group {
  position: relative;

  .icon-bdImg,
  .baiduSearch-uploader {
    position: absolute;
    width: 50px;
    height: 80%;
    right: 40px;
    top: 12%;
    cursor: pointer;
  }

  .baiduSearch-uploader {
    right: 0;
  }

  .icon-bdImg {
    background-image: url("~@/assets/images/icons/icon-bdImg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    display: block;
    z-index: 99;

    p {
      display: none;
      position: absolute;
      top: 35px;
      left: -22px;
      border-radius: 8px;
      padding: 10px;
      background: #fff;
      width: 100px;
      text-align: center;
      font-size: 14px;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
      z-index: 9;
    }

    &:hover {
      background-image: url("~@/assets/images/icons/icon-bdImg-active.png");

      p {
        display: block;
      }
    }
  }

  .icon-close {
    background-image: url("~@/assets/images/icons/icon-close.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    display: block;
    width: 40px;
    height: 40px;
    position: absolute;
    right: 8px;
    bottom: 0px;
    cursor: pointer;

    &:hover {
      background-image: url("~@/assets/images/icons/icon-close-active.png");
    }
  }

  .baiduSearch-uploader {
    min-width: 50px;
    width: auto;

    .el-upload {
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    .avatar-uploader-icon {
      width: 100%;
      height: 100%;
    }
  }

  .upload-bdimg-c {
    position: absolute;
    left: 4px;
    top: 65px;
    border-radius: 20px;
    width: 48vw;
    min-height: 80px;
    background: #fff;
    overflow: hidden;
    padding: 20px 20px 40px;

    .upload-bdimg {
      position: relative;

      .el-upload {
        width: 100%;
      }

      .el-upload-dragger {
        width: 100%;
        height: 80px;
      }

      .el-icon-upload {
        display: none;
      }

      .el-upload__text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .el-upload-list {
      display: none;
    }
  }
}
</style>
